import { CreateRolePage } from "../CreateRolePage/CreateRolePage";

export function EditRolePage() {
  return <CreateRolePage />;
}
